import InAppNotificationEndpoint from '@/modules/in-app-notification/api/inAppNotificationEndpoint'

export const notificationEndpoints = new InAppNotificationEndpoint()
